import { NavLink } from 'react-router'
import { COPYRIGHT } from '~/config'
import {
  footerColumnsDesktop,
  footerColumnsMobile,
  type FooterLink as FooterLinkData,
  type FooterSection as FooterSectionData,
} from '~/config/footerData'
import { LinkedInIcon, FormerlyKnownAsTwitterIcon, YouTubeIcon } from '../icons'
import { Wordmark } from '~/components'
import { FooterCta } from '../footer-cta/footer-cta'

const FooterLink = ({ link }: { link: FooterLinkData }) => {
  const content = link.badge ? (
    <>
      <span className="careers-label">{link.label}</span>
      <span className="hiring-badge">{link.badge}</span>
    </>
  ) : (
    link.label
  )

  if (link.external) {
    return (
      <a
        className={link.badge ? 'careers' : undefined}
        href={link.to}
        target="_blank"
        rel="noreferrer"
      >
        {content}
      </a>
    )
  }

  return (
    <NavLink className={link.badge ? 'careers' : undefined} to={link.to}>
      {content}
    </NavLink>
  )
}

const FooterSection = ({ section }: { section: FooterSectionData }) => (
  <div className="footer-section">
    <h4>{section.title}</h4>
    {section.links.map((link) => (
      <FooterLink key={link.to} link={link} />
    ))}
  </div>
)

const FooterColumns = ({
  columns,
  variant,
}: {
  columns: FooterSectionData[][]
  variant: 'desktop' | 'mobile'
}) => (
  <ul className={`footer-links ${variant}`}>
    {columns.map((column) => (
      <li
        className={`footer-${variant}-column`}
        key={column.map((section) => section.key).join('-')}
      >
        {column.map((section) => (
          <FooterSection key={section.key} section={section} />
        ))}
      </li>
    ))}
  </ul>
)

export const Footer = () => {
  return (
    <footer className="app">
      <FooterCta />
      <div className="footer-inner">
        <aside>
          <NavLink
            to="/"
            className="footer-logo-link"
            aria-label="Omni homepage"
          >
            <Wordmark tone="light" />
          </NavLink>

          <div className="copy-and-social">
            <ul>
              <li>
                <a
                  href="https://www.linkedin.com/company/exploreomni/"
                  rel="noreferrer noopener"
                  target="_blank"
                  aria-label="Omni on LinkedIn"
                >
                  <LinkedInIcon />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@omni_analytics"
                  rel="noreferrer noopener"
                  target="_blank"
                  aria-label="Omni on YouTube"
                >
                  <YouTubeIcon />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/Omni"
                  rel="noreferrer noopener"
                  target="_blank"
                  aria-label="Omni on X"
                >
                  <FormerlyKnownAsTwitterIcon />
                </a>
              </li>
            </ul>
            <div className="copy-and-legal">
              <p>{COPYRIGHT}.</p>
              <p>
                <NavLink to="/privacy">Privacy</NavLink> |{' '}
                <NavLink to="/terms">Terms</NavLink>
              </p>
            </div>
          </div>
        </aside>

        <nav>
          <FooterColumns columns={footerColumnsDesktop} variant="desktop" />
          <FooterColumns columns={footerColumnsMobile} variant="mobile" />
        </nav>
      </div>
    </footer>
  )
}
